<template>
    <div class="text-center">
        <v-overlay v-model="overlayState" :value="overlayState" opacity="1">
            <v-row align="center" class="grey darken-4 text-center filePreviewHeader pt-1">
                <v-col class="pa-0 mt-1 mb-1">
                    <v-spacer></v-spacer>
                    <v-btn dark @click="close()" class="mr-1">
                        <v-icon>mdi-close</v-icon>
                        Fechar
                    </v-btn>
                    <!-- <v-btn dark @click="download(file.url, file.name.indexOf('_') + 1)" class="ml-1">
                        <v-icon>mdi-download</v-icon>
                        Download
                    </v-btn> -->
                    <v-spacer></v-spacer>
                </v-col>
            </v-row>
            <div v-show="isLoading" class="loader-container">
                <v-progress-linear
                    height="25"
                    rounded
                    striped
                    indeterminate
                ></v-progress-linear>
            </div>
            <div v-show="!isLoading">
                <vue-friendly-iframe
                    v-if="!isImage"
                    id="i_frame"
                    :src="urlFormated"
                    className="iframe-inner"
                    style="width:100vw; height:95vh;"
                    frameborder="0"
                    @load="ready"
                ></vue-friendly-iframe>
                <div
                    v-else
                    style="width:100vw; height:95vh;"
                    class="filePreviewImage"
                >
                    <img :src="urlFormated" @load="ready"/>
                </div>
            </div>
        </v-overlay>
    </div>
</template>

<script>
export default {
    name: 'filepreview',
    props: ['overlay', 'file'],
    data: () => ({
        overlayState: false,
        isLoading: true,
        isImage: false,
        urlFormated: ''
    }),
    mounted () {
        this.init()
    },
    watch: {
        overlay: function (val, oldVal) {
            this.overlayState = val
        },
        overlayState: function (val, oldVal) {
            this.init()
            this.$emit('update:overlay', val)
        }
    },
    methods: {
        init () {
            if (this.file === undefined || this.file === null) {
                this.isImage = false
                this.urlFormated = ''
            } else {
                if ((/\.(gif|jpe?g|tiff?|png|webp|bmp)$/i).test(this.file.url)) {
                    this.isImage = true
                    this.urlFormated = this.file.url
                } else {
                    this.isImage = false
                    this.urlFormated = `https://docs.google.com/viewer?url=${this.file.url}&embedded=true`
                }
            }
        },
        ready () {
            this.isLoading = false
        },
        forceFileDownload (response, title) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', title)
            document.body.appendChild(link)
            link.click()
        },
        download (url, title) {
            this.$http.get(
                url,
                {
                    credentials: false
                }
            ).then(response => {
                this.forceFileDownload(response, title)
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        close () {
            this.isImage = false
            this.urlFormated = ''
            this.overlayState = false
            this.isLoading = true
        }
    }
}
</script>

<style lang="stylus" scoped>
    .filePreviewImage
        img
            max-width: 100%
            max-height: 100%

    .loader-container
        height: 95vh
        width: 100vw
        display: flex
        align-items: center
        justify-content: center

        div
            max-width: 50%

    .vue-friendly-iframe
        width: 100vw
        height: 95vh
</style>

<style lang="stylus">
    .iframe-inner
        width: 100vw
        height: 95vh
</style>
